module.exports = ".mat-list-item-icon {\n  margin-right: 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/consulta.component.scss
// module id = ./src/app/consulta/consulta.component.scss
// module chunks = main